import React from 'react'
import { useCore } from '../../../hooks'
import { ControlledInput } from '../../../components/Form/Controlled/ControlledInput'
import { UseFormReturn, useWatch } from 'react-hook-form'
import { ControlledSelect } from '../../../components/Form/Controlled/ControlledSelect'
import { AddressUpdate } from '../lib/types'
import { useBasicEntities } from '../../../context/BasicEntitiesContext'

// US States list
const US_STATES = [
  { label: 'Nezadáno', value: null },
  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' },
]

type Props = {
  form: UseFormReturn<AddressUpdate>
  error?: string
}

export const Address: React.FC<Props> = ({ form, error }) => {
  const { countries } = useBasicEntities()
  const { control } = form
  const country = useWatch({ control, name: 'country' })
  const isUS = country === 'US'
  const countriesToSelect = [
    { label: 'Nezadáno', value: null },
    ...(countries || []).map(c => ({ label: c.name, value: c.code })),
  ]

  return (
    <div className="box">
      {error && <div className="font-bold text-red">{error}</div>}
      <div className={'grid grid-cols-4 gap-2'}>
        <ControlledInput
          className={'col-span-2'}
          label={'Jméno'}
          name={'firstName'}
          control={control}
          rules={{ required: 'Jméno je povinne' }}
        />
        <ControlledInput
          className={'col-span-2'}
          label={'Příjmení'}
          name={'lastName'}
          control={control}
          rules={{ required: 'Příjmení je povinne' }}
        />
        <ControlledInput className={'col-span-2'} label={'Telefon'} name={'phone'} control={control} />
        <ControlledInput className={'col-span-2'} label={'E-mail'} name={'email'} control={control} />
        <ControlledInput className={'col-span-4'} label={'Společnost'} name={'companyName'} control={control} />
        <ControlledInput className={'col-span-2'} label={'IČ'} name={'ic'} control={control} />
        <ControlledInput className={'col-span-2'} label={'DIČ'} name={'dic'} control={control} />
        <ControlledInput className={'col-span-4'} label={'Ulice a č.p.'} name={'street'} control={control} />
        <ControlledInput className={'col-span-1'} label={'PSČ'} name={'zip'} control={control} />
        <ControlledInput className={'col-span-3'} label={'Město'} name={'city'} control={control} />
        <ControlledSelect
          className={'col-span-1'}
          label={'Země'}
          options={countriesToSelect}
          name={'country'}
          control={control}
        />
        {isUS && (
          <ControlledSelect
            className={'col-span-1'}
            label={'Stát'}
            options={US_STATES}
            name={'state'}
            control={control}
          />
        )}
        <ControlledInput
          className={isUS ? 'col-span-2' : 'col-span-3'}
          label={'ID pobočky'}
          name={'branchId'}
          control={control}
        />
      </div>
    </div>
  )
}
